<template>
    <b-modal id="jerseyModal" v-model="showJersey" :hide-footer="true">
        <div id="busForm">
			<div class="formTitle">
				<svg-image image="iconJersey"/>
				<h5>{{ $t("register.form.detail.jersey") }}</h5>
			</div>

            <b-form @submit="doJersey">
                <img src="https://assets.heartwork.co.id/bormar/jersey.jpg" alt="Jersey">
				<b-form-group id="" :label="$t('register.form.detail.jersey')" label-for="" :description="$t('register.form.detail.jerseyd')">
						<b-form-select v-model="jerseySize">
							<b-form-select-option value="XS">XS</b-form-select-option> 
							<b-form-select-option value="S">S</b-form-select-option>
							<b-form-select-option value="M">M</b-form-select-option>
							<b-form-select-option value="M">L</b-form-select-option>
							<b-form-select-option value="XL">XL</b-form-select-option>
							<b-form-select-option value="2XL">XXL</b-form-select-option>
							<b-form-select-option value="3XL">XXXL</b-form-select-option>
						</b-form-select>
				</b-form-group>
                <!-- <b-form-checkbox
					id="acceptance"
					v-model="formChecked"
					name="acceptance"
					value="accepted"
					unchecked-value="not_accepted"
					>
					{{ $t("register.form.acceptance") }}
				</b-form-checkbox> -->
                <div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg"><b-spinner small type="grow" v-if="loading"></b-spinner> {{ $t("register.form.jbtn") }}</b-button>
				</div>
            </b-form>
        </div>
    </b-modal>
</template>
<script>
	import SvgImage from '../components/SvgImage.vue';
	export default {
		data () {
			return {
				jerseySize: undefined,
				loading: undefined
			}
		},		
		props: {
			transactionData:Object,
			showJersey: Boolean,
		},
	    components : {  
		    SvgImage,
	    },
		methods: {
			doJersey(e){
				e.preventDefault();
				var _data = {
					participantId : this.$parent.ballotDataDetail.evpaId, 
					jerseyId : this.jerseySize
				}
				console.log('Doing jersey... ', _data);

				this.$store.dispatch('SETJERSEY',{data:_data})
					.then(jerseyOutput=>{
						console.log(jerseyOutput);
						this.$parent.init();
						this.$parent.showJerseyModal = false;
						this.$parent.showPaymentModal = true;
						// this.$store.dispatch('GETTRANSACTION', {data:this.transactionData.data.trnsRefId})
						// 	.then((transactionOut)=>{
						// 		this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
						// 		this.transactionData = transactionOut.data;
						// 		console.log('Transaction out : ', transactionOut);
						// 	})
						// 	.catch((err)=>{
						// 		console.log(err);
						// 	})
					})
					.catch(err=>{
						// console.log(this.$parent)
						if (err.response){
							this.status = err.response;						
						}
					})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// JerseyModal.vue